import React from "react";
import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const WhatsAppButton = () => {
  const { t } = useTranslation();
  return (
    <a
      href="https://wa.me/34624511532"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-[60] bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:bg-[#20bd5a] transition-all duration-300 hover:scale-110 group animate-bounce-slow"
      aria-label={t("whatsapp.ariaLabel")}
    >
      <MessageCircle className="w-7 h-7" />
      <span className="absolute right-full mr-4 bg-[#0C2340] text-white px-4 py-2 rounded-xl text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none shadow-xl border border-white/10">
        {t("whatsapp.tooltip")}
      </span>
    </a>
  );
};

export default WhatsAppButton;
